import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import contractApi from '../../../APIs/contract';
import ClientInformation from '../../../components/ClientContract/ClientInformation';
import ContractDetail from '../../../components/ClientContract/ContractDetail';
import CostShipping from '../../../components/ClientContract/CostShipping';
import JobInformation from '../../../components/ClientContract/JobInformation';
import PropertyInformation from '../../../components/ClientContract/PropertyInformation';
import AdditionalRequirement from '../../../components/Contract/AdditionalRequirement';
import {
  Button,
  Divider,
  NavigateBack,
  Tag,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDate, requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import { ActionsContainer } from './style';

type Props = {};

const ClientContractDetails = (_props: Props) => {
  const { clientContractId } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const contractDetails = useSelector(
    (state: RootState) => state.contractDetails,
  );
  const contractStatus = contractDetails?.contractStatus;
  const handleContractDetails = async (id: string) => {
    try {
      requestAPI(contractApi.getContractDetails(id));
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (clientContractId) {
      handleContractDetails(clientContractId);
    }
  }, []);

  const handleCancelContract = async () => {
    try {
      setLoading(true);
      if (clientContractId) {
        await requestAPI(
          contractApi.updateContractStatus(clientContractId, {
            status: 'CANCEL',
          }),
        );
        setLoading(false);
        navigate(-1);
        toast.success('contract canceled successfully');
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const buildingInfo =
    typeof contractDetails?.jobId?.building === 'string'
      ? undefined
      : contractDetails?.jobId?.building;

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="normal" style={{ marginBottom: '15px' }}>
            Contract Details{' '}
          </Typography>
          <div>
            {contractStatus === 'ACCEPT' && <Tag type="success">ACCEPTED</Tag>}
            {contractStatus === 'DECLINE' && <Tag type="danger">DECLINED</Tag>}
            {contractStatus === 'CANCEL' && <Tag type="danger">CANCELLED</Tag>}
            {contractStatus === 'PENDING' && <Tag type="warning">PENDING</Tag>}
          </div>
        </div>
        <Divider />

        <JobInformation
          createdAt={humanReadableDate(contractDetails?.jobId?.createdAt || '')}
          jobTitle={contractDetails?.jobId?.jobTitle || ''}
          notes={contractDetails?.jobId?.notes || ''}
        />
        <Divider />
        <PropertyInformation
          buildingName={buildingInfo?.buildingName || ''}
          buildingAddress={buildingInfo?.buildingAddress || ''}
        />
        <Divider />
        <CostShipping
          pricing={contractDetails?.jobId?.pricing || ''}
          shippingAddress={contractDetails?.jobId?.shippingAddress || ''}
        />
        <Divider />
        <ClientInformation
          fullName={contractDetails?.technicianId?.fullName}
          email={contractDetails?.technicianId?.emailAddress}
        />
        <Divider />

        <AdditionalRequirement title={'Test Title'} value={'Test Value'} />
        <Divider />
        <ContractDetail />
        <Divider spaceY="20px" />

        {contractStatus === 'PENDING' ? (
          <>
            <Typography
              variant="normal"
              strong
              fontColor="secondary"
              className="section-title"
            >
              ACTIONS
            </Typography>
            <ActionsContainer>
              <Button
                variant="danger"
                size="sm"
                width="122px"
                isLoading={loading}
                onClick={() => handleCancelContract()}
              >
                Cancel Contract
              </Button>
            </ActionsContainer>
          </>
        ) : (
          ''
        )}
      </div>
    </ViewJobContainerStyled>
  );
};

export default ClientContractDetails;
